<template>
  <v-container id="uploadCenter">
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="10" md="6" class="pb-0">
        <p class="headline font-weight-light">Rollen</p>
      </v-col>
    </v-row>
    <v-tabs
            v-model="tab"
            background-color="#EEEEEE"
            color="black"
            grow
    >
      <v-tab>Rolle</v-tab>
      <v-tab>Rechte</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>

          <v-form>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="10" md="6">
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                    label="Name"
                    clearable
                    height="56"
                    outlined
                    v-model="formData.name"
                    dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                    label="Kommentar"
                    clearable
                    height="56"
                    outlined
                    v-model="formData.comment"
                    dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-btn @click="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
                  </v-col>
                  <v-col cols="6" class="py-0 text-right">
                    <v-btn @click="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
                    </v-btn>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>
          </v-form>
      </v-tab-item>
      <v-tab-item>
        <TableRechte :roleId="guid"></TableRechte>
      </v-tab-item>
    </v-tabs-items>


  </v-container>
</template>

<script>
import Vue from 'vue'
import TableRechte from "../../tables/TableRechte";
// import swal from 'sweetalert2'

export default {
  name: 'AppsDefault',
  components: {TableRechte},
  data () {
    return {
      statusList: [
        {
          key: 0,
          title: 'Nein'
        },
        {
          key: 1,
          title: 'Ja'
        }
      ],
      companyGuid: '',
      guid: 0,
      tab: 0,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        changed: ''
      },
      progress: 100,
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      }
    }
  },
  methods: {
    onGetData: function (data) {
      this.formData = data
    },
    onItemUpdated: function () {
      this.cancelItem()
    },
    cancelItem: function () {
      if (this.companyGuid) {
        this.$router.push('/Netzwerke/' + this.companyGuid + '/2')
      } else {
        this.$router.push('/Dashboard/Rollen')
      }
    },
    updateItem: function () {
      Vue.prototype.$apiRole.update(this.guid, this.formData, this.onItemUpdated)
    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
    this.guid = this.$route.params.guid
    this.companyGuid = this.$route.params.companyId
    Vue.prototype.$apiRole.loadById(this.guid, this.onGetData)
  }
}
</script>

<style scoped>

</style>
